import { useGiayBaoCoContext } from './search-context';
import { useGiayBaoCoImport } from './useGiayBaoCoImport';
import { useGiayBaoCoMutation } from './useGiayBaoCoMutation';
import { useGiayBaoCoTable } from './useGiayBaoCoTable';

export const useGiayBaoCoPage = () => {
  const { isExporting } = useGiayBaoCoContext();
  const tableState = useGiayBaoCoTable();
  const importState = useGiayBaoCoImport({ refreshData: tableState.crud.refreshData });
  const mutationState = useGiayBaoCoMutation({
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData
  });

  return {
    searchDialog: tableState.searchDialog,
    formDialog: {
      open: tableState.form.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.form.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    multipleFormDialog: tableState.multipleFormDialog,
    deleteDialog: {
      open: tableState.form.showDelete,
      onClose: tableState.form.handleCloseDelete,
      selectedObj: tableState.selection.selectedObj,
      onDelete: tableState.crud.deleteItem,
      clearSelection: tableState.selection.clearSelection
    },
    bulkDeleteDialog: {
      open: tableState.form.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    importDialog: importState.importDialog,
    importErrorDialog: importState.importErrorDialog,
    table: tableState.table,
    detailTable: tableState.detailTable,
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleSearch: tableState.searchDialog.onOpen,
      handleRefresh: tableState.table.onRefresh
    },
    selection: tableState.selection
  };
};
